import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { 
   IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvColorPrimary } from '@marv/types';
import { 
    MarvSelectItem, MarvSelectComponent, MarvRatingComponent, MarvToggleComponent, MarvButtonComponent, MarvMessageComponent 
} from '@marv/components';
import { MissionDetails } from '@app/components';
import { CustomerFeedbackService, OrderService } from '@app/services';
import { CustomerFeedBackValue } from '@app/models';

@Component({
    selector: 'app-mission-details-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
    imports: [
        IonIcon, ReactiveFormsModule, TranslatePipe, 
        forwardRef(() => MarvSelectComponent), forwardRef(() => MarvRatingComponent), forwardRef(() => MarvToggleComponent), 
        forwardRef(() => MarvButtonComponent), forwardRef(() => MarvMessageComponent)
    ]
})
export class MissionDetailsRatingComponent  implements OnInit {

    @Input({alias : 'mission', required : true}) missionDetails: MissionDetails;
    
    ratingValue: number|null = null;
    ratingMax: number;    
    ranking: Array<CustomerFeedBackValue> = [];
    customerFeedbackComments: Array<MarvSelectItem> = [];    
    ratingForm: FormGroup = new FormGroup({
        customerFeedback: new FormControl(null, Validators.required),
        incidentDeclared: new FormControl(false),
        customerFeedbackComment: new FormControl(null)
    });
    errorMsg: string = '';
    successMsg: string = '';
    isFetchingSave: boolean = false;
    
    constructor(
        private orderService: OrderService
    ) { }

    async ngOnInit() {
        
        let ratingValue: number|null = null;
        let customerFeedbackComment: number | null = null;
        
        this.ranking = CustomerFeedbackService.CustomerFeedBackValues;        
        this.ratingMax = this.ranking.length;
               
        let customerFeedbackComments: Array<MarvSelectItem> = [];   
        let comments = CustomerFeedbackService.CustomerFeedBackCommentsValues;
        if(comments){            
            for(let c of comments){
                customerFeedbackComments.push({
                    label: c.libelle,
                    value: c.id,
                    color: MarvColorPrimary
                });
            }
        }
        this.customerFeedbackComments = customerFeedbackComments;
        
        if(this.missionDetails){
            ratingValue = this.ranking.find(r => r.value === this.missionDetails.customerFeedback)?.rank || null;
            customerFeedbackComment = this.missionDetails.customerFeedbackComment;
        }

        this.ratingValue = ratingValue;            
        this.ratingForm.controls['customerFeedback'].setValue(ratingValue);
        this.ratingForm.controls['customerFeedbackComment'].setValue(customerFeedbackComment);            
        this.ratingForm.controls['incidentDeclared'].setValue((customerFeedbackComment !== null));
    }
    
    selectRating(rate: number){
        this.ratingForm.controls['customerFeedback'].setValue(rate);
        if(this.disabledComment()){
            this.ratingForm.controls['customerFeedbackComment'].setValue(null);
        }
    }
    
    disabledComment(): boolean{
        return (this.ratingForm.controls['customerFeedback'].value !== 1 && !this.ratingForm.controls['incidentDeclared'].value);
    }
    
    async setFeedback(){
        
        this.errorMsg = '';
        this.successMsg = '';
        this.isFetchingSave = true;
        
        if(this.ratingForm.valid){            
            if((this.ratingForm.controls['customerFeedback'].value === 1 || this.ratingForm.controls['incidentDeclared'].value) && !this.ratingForm.controls['customerFeedbackComment'].value){
                this.errorMsg = 'MSG_ERROR_SELECT_COMMENT_RATING';
            }
            else{
                let res = true;
                if(this.disabledComment()){
                    this.ratingForm.controls['customerFeedbackComment'].setValue(null);
                }
                
                if(this.ratingForm.controls['customerFeedback'].value){
                    let ratingValue = this.ranking.find(r => r.rank === this.ratingForm.controls['customerFeedback'].value)?.value || null;
                    if(ratingValue){
                        res = res && await this.orderService.updateCustomerFeedBack(this.missionDetails.missionId, ratingValue);
                    }
                }
                res = res && await this.orderService.updateCustomerFeedBackComment(this.missionDetails.missionId, this.ratingForm.controls['customerFeedbackComment'].value);
                
                if(res){
                    this.successMsg = 'MSG_SUCCESS_RATING';
                }
                else{
                    this.errorMsg = 'MSG_ERROR_RATING';
                }
            }
        }
        else if(!this.ratingForm.controls['customerFeedback'].value){
            this.errorMsg = 'MSG_ERROR_SELECT_RATING';
        }
        
        if(this.errorMsg !== ''){            
            for (var controlName in this.ratingForm.controls) {
                if(!this.ratingForm.controls[controlName].valid) {
                    this.ratingForm.controls[controlName].markAsTouched();
                }
            }
        }
        
        this.isFetchingSave = false;
    }
}
